/**
 * Official registered / correspondence address (footer, contact, legal pages).
 */
export const COMPANY_OFFICE_ADDRESS_LINES = [
  'B-128, First Floor, Sector-2',
  'Gautam Buddha Nagar, Uttar Pradesh 201301',
  'India',
];

/** Member / public support (FAQ, contact, mailto helpers). */
export const SUPPORT_EMAIL = 'hello@unaffectedhealthcare.in';

/** Operations contact published on partnership / support materials. */
export const SUPPORT_PHONE = '+91 9717619904';

/** Pre-filled message when opening WhatsApp support chat. */
export const SUPPORT_WHATSAPP_PREFILL = 'Hi Team, I Need support.';

/** Shown in UI to set expectations after user opens WhatsApp support. */
export const SUPPORT_AUTO_REPLY_MESSAGE =
  'Dear User, thank you for reaching out. Our team will contact you in 5 minutes.';

/** Support availability hours shown on Benefits Help card. */
export const SUPPORT_HOURS = 'Available from 10:00 am to 07:00 pm';
